import React from "react"

import EcosuiteComponent from "@common/EcosuiteComponent"
import WidgetService from "./WidgetService"

import Logger from "@common/Logger"

import defaultWidgets from "./DefaultWidgets"

export default class InfoWidgetsSidebar extends EcosuiteComponent {
  constructor(props) {
    super(props)
    this.state = {
      widgetList: "null",
    }
  }

  componentDidMount() {
    super.componentDidMount()
    WidgetService.getWidgetList(this.props.userId)
      .then((data) => {
        if (data && data.widgets != null) {
          Logger.debug("List found!", data.widgets)
          this.setStateIfMounted({ widgetList: data.widgets.Attributes })
        } else {
          this.setStateIfMounted({ widgetList: defaultWidgets.applications })
        }
      })
      .catch((error) => {
        Logger.debug("Error loading widget list, falling back to defaults", error)
        this.setStateIfMounted({ widgetList: defaultWidgets.applications })
      })
  }

  renderWidget(widget) {
    if (widget.enabled !== true) {
      return
    }
    return this.props.widgets[widget.name]
  }

  renderWidgets() {
    let sideBar = []
    if (this.state.widgetList !== "null") {
      const applicationIndex = this.state.widgetList.findIndex((e) => e.name === this.props.ecosuiteVeiw)
      if (applicationIndex !== -1 && this.state.widgetList[applicationIndex].widgets) {
        this.state.widgetList[applicationIndex].widgets.forEach((widget, index) => {
          const renderedWidget = this.renderWidget(widget)
          if (renderedWidget) {
            sideBar.push(<div key={index}>{renderedWidget}</div>)
          }
        })
      } else {
        Logger.debug("Application not found or no widgets available")
      }
    }
    return <React.Fragment>{sideBar}</React.Fragment>
  }

  render() {
    return this.renderWidgets()
  }
}
